export default {
    Get: {
        PROPERTY_SEARCH_PARAM: 'getPropertySearchParam',
        PERSON_SEARCH_PARAM: 'getPersonSearchParam',
        DEMAND_SEARCH_PARAM: 'getDemandSearchParam',
        TASK_SEARCH_PARAM: 'getTaskSearchParam'
    },
    Set: {
        PROPERTY_SEARCH_PARAM: 'setPropertySearchParam',
        PERSON_SEARCH_PARAM: 'setPersonSearchParam',
        DEMAND_SEARCH_PARAM: 'setDemandSearchParam',
        TASK_SEARCH_PARAM: 'setTaskSearchParam'
    }
};